export enum TimecardActions {
  None = 0,
  Save,
  Submit,
  Approve,
  Reject,
  UndoApprove,
  UndoReject
}
